import * as VideoProcessors from './twilioProcessors'
import getEnvironment from '@bt-react/libs/getEnvironment'
import { PresenterBackground, VirtualBackgrounds } from '../../components/VirtualBackgroundPicker/VirtualBackgroundPicker'


export const applyBackground = async (videoTrack, background: PresenterBackground) => {

  const { env } = getEnvironment()
  const assetsPath = env === 'development' ? '/assets' : '/talks/assets'

  if (!videoTrack) return

  if (videoTrack.processor) {
    videoTrack.removeProcessor(videoTrack.processor)
  }

  if (background.type === VirtualBackgrounds.BLUR_HIGH) {
    const blurBackground = new VideoProcessors.GaussianBlurBackgroundProcessor({
      assetsPath,
      maskBlurRadius: 20,
      blurFilterRadius: 15,
    })
    await blurBackground.loadModel();
    videoTrack.addProcessor(blurBackground)
    return
  }

  if (background.type === VirtualBackgrounds.BLUR_LOW) {
    const blurBackground = new VideoProcessors.GaussianBlurBackgroundProcessor({
      assetsPath,
      maskBlurRadius: 20,
      blurFilterRadius: 7,
    })
    await blurBackground.loadModel();
    videoTrack.addProcessor(blurBackground)
    return
  }

  if (background.type === VirtualBackgrounds.SOLID_COLOR) {
    const backgroundImage = new Image()
    backgroundImage.crossOrigin = 'anonymous'
    backgroundImage.src = `${assetsPath}/solid-color-bg.png`
    backgroundImage.onload = async () => {
      const virtualBackground = new VideoProcessors.VirtualBackgroundProcessor({
        assetsPath,
        maskBlurRadius: 5,
        backgroundImage
      })
      await virtualBackground.loadModel()
      videoTrack.addProcessor(virtualBackground)
      return
    }
  }

  if (background.type === VirtualBackgrounds.IMAGE && background.customImage) {
    const backgroundImage = new Image()
    backgroundImage.crossOrigin = 'anonymous'
    backgroundImage.src = background.customImage
    backgroundImage.onload = async () => {
      const virtualBackground = new VideoProcessors.VirtualBackgroundProcessor({
        assetsPath,
        maskBlurRadius: 5,
        backgroundImage
      })
      await virtualBackground.loadModel()
      videoTrack.addProcessor(virtualBackground)
      return
    }
  }

}